import { useEffect, useRef } from 'react';

import {
  clearBackgroundMode,
  selectIsBackgroundMode,
} from '@/shared/redux/background-refetch/background-refetch.slice';
import { useAppDispatch, useAppSelector } from '@/shared/redux/hooks/hooks';

export const useBackgroundRefetch = (isFetching: boolean): boolean => {
  const dispatch = useAppDispatch();
  const isBackgroundMode = useAppSelector(selectIsBackgroundMode);
  const prevIsFetching = useRef(false);
  const isCurrentFetchBackground = useRef(false);

  if (isFetching && !prevIsFetching.current) {
    isCurrentFetchBackground.current = isBackgroundMode;
  }
  prevIsFetching.current = isFetching;

  useEffect(() => {
    if (!isFetching && isCurrentFetchBackground.current) {
      dispatch(clearBackgroundMode());
      isCurrentFetchBackground.current = false;
    }
  }, [isFetching]);

  return isFetching && !isCurrentFetchBackground.current;
};
